import { useEffect } from "react";
import Logger from "../utils/Logger";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalStorage } from "../utils/Utils";

const routes = [
  "/reset-password",
  "/reset-link",
  "/sign-up",
  "/forgot-password",
  "/dashboard/profile",
  "/dashboard/settings",
  "/dashboard/services",
  "/dashboard/livesession",
  "/dashboard/our-services",
  "/dashboard/student",
  "/dashboard/student/skills-details",
  "/dashboard/assessment",
  "/dashboard/assessment/allAssessment",
  "/dashboard/assessment/allAssessment/instruction",
  "/dashboard/assessment/allAssessment/instruction/otp",
  "/dashboard/recommendation",
  "/dashboard/learning-room",
  "/text-recommendation",
  "/dashboard/assessment/student",
  "/dashboard/recommendation/jozunaview",
  "/dashboard/learning-room/view-courses",
  "/dashboard/recommendation/jozunaview/video",
  "/dashboard/learning-room/view-courses/video",
  "/dashboard/learning-room/view-labsession/video",
  "/dashboard/programSchedule",
  "/dashboard/ourservices",
  "/dashboard/assessment/instruction/otp",
  "/dashboard/audio",
  "/reset_password/user/", // dynamic token
  "/dashboard/",
  "/speedtest", // wildcard
];

export default function RouteValidator() {
  const navigate = useNavigate();
  const location = useLocation();
      const storedToken = LocalStorage.getLocalData("access_token");
  useEffect(() => {
    const path = location.pathname;

    const isValid = routes.some((route) => {
      // dynamic token route
      if (route === "/reset_password/user/") return path.startsWith(route);
      // wildcard dashboard route
      if (route === "/dashboard/") return path.startsWith(route);
      // exact match
      return route === path;
    });

    Logger.info("Current path:", path, "isValid:", isValid);

    if (!isValid) {
      // Redirect to login WITHOUT reload to avoid loop
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}


